export default __webpack_public_path__ + "static/media/misc003.8739e59b.jpeg";